package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_06_06_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes deep under the Gideon forest. On their way to the surface, Tuesday and Dirk see signs of demon ichor. Caper, Annette, and Falorn think the Drow defeated demons and chased them out of the caverns. The Drow probably didn’t know about the shard of the shield of Concar; they just knew there was something powerful secured behind the field of force. On the surface, Caper reunites with Aloysius, who has been diligently guarding the entrance. As Tuesday begins to draw a teleport circle back to Freeburg, the heroes discuss that the Powerglow guild has politely asked to be notified prior to teleportation; the heroes unanimously agree not to notify.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The Powerglow guild is shocked by the surprise arrival of the Friends of the Forest. Elrovir Rodiridan bids farewell. Stadler Feyless greets the heroes at their bastion. He has been working on the keep, stables, and barracks and has more than enough funds.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Razorwrath speaks to Bigglesworth, demanding to be fed magical items by tomorrow so he can get strong.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The heroes look over their map of remaining Shard locations and choose Pentish as their next destination.")
    }
}
